import React, { createContext, useContext, useState, useCallback } from 'react';
import AppointmentAlertModal from '../components/AppointmentAlertModal';

const AppointmentAlertContext = createContext(null);

/**
 * Proveedor global de alertas de citas.
 * Envuelve la app para que cualquier módulo pueda disparar la alerta.
 */
export const AppointmentAlertProvider = ({ children }) => {
  const [alertData, setAlertData] = useState(null);

  /**
   * Dispara la alerta visual de cita.
   * @param {object} data
   *   tipo        — 'nueva' | 'reagendada' *   origen      —'CRM' | 'Solicitudes' | 'Portal Cliente' | 'Recepción' | 'Ventas' | 'Órdenes' | ...
   *   cliente     — string
   *   telefono    — string (opcional)
   *   vehiculo    — string (opcional)
   *   placa       — string (opcional)
   *   servicio    — string
   *   fecha       — string "YYYY-MM-DD" *   hora        — string"HH:MM"
   *   notas       — string (opcional)
   *   usuario     — string (nombre del usuario que la generó)
   */
  const showAppointmentAlert = useCallback((data) => {
    setAlertData({ ...data, createdAt: new Date()?.toISOString() });
  }, []);

  const handleClose = useCallback(() => {
    setAlertData(null);
  }, []);

  return (
    <AppointmentAlertContext.Provider value={{ showAppointmentAlert }}>
      {children}
      {alertData && (
        <AppointmentAlertModal data={alertData} onClose={handleClose} />
      )}
    </AppointmentAlertContext.Provider>
  );
};

export const useAppointmentAlert = () => {
  const ctx = useContext(AppointmentAlertContext);
  if (!ctx) throw new Error('useAppointmentAlert must be used within AppointmentAlertProvider');
  return ctx;
};
